import {Component, ContentChild, Host, input, Input} from '@angular/core';
import {ControlContainer} from '@angular/forms';
import {FormControlComponent} from '../../base/form-control.component';
import {convertPrice} from '../../utils/convert-price.util';

@Component({
	selector: 'tvcore-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
	standalone: false
})
export class InputComponent extends FormControlComponent {
	@Input()
	autocomplete: boolean;
	@Input()
	label: string;
	@Input()
	large?: boolean = false;
	@Input()
	min: number;
	@Input()
	max: number;
	@Input()
	maxlength: number;
	@Input()
	type: 'email' | 'number' | 'price' | 'price-decimal' | 'tel' | 'text' | 'textarea' | 'url' = 'text';
	@ContentChild('innerTemplate')
	innerTemplate: any;

	roundPrice = input(false);

	constructor(@Host() controlContainer: ControlContainer) {
		super(controlContainer);
	}

	allowPriceDecimalKeys(event: KeyboardEvent) {
		const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',', 'Backspace', 'Tab', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft', ' '];
		if (!allowedKeys.includes(event.key) && !event.ctrlKey && !event.metaKey) {
			event.preventDefault();
		}
	}

	getLength(): number {
		if (this.control && this.control.value && this.maxlength) {
			return this.maxlength - this.control.value.length;
		}

		return this.maxlength;
	}

	formatNumber() {
		let value: number | null = parseInt(this.control!.value, 10);

		if (isNaN(value)) {
			value = null;
		}

		this.control!.setValue(value);
	}

	formatPrice() {
		let value: number | null = convertPrice(this.control!.value, this.roundPrice());

		if (isNaN(value || 0)) {
			value = null;
		}

		if (value || value === 0) {
			const n = value.toString(10).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
			this.control!.setValue(n);
			return;
		}

		this.control!.setValue(null);
	}

	formatPriceDecimal() {
		const value = this.control?.value || '';

		// Verwijder alle spaties
		let cleaned = value.toString().replace(/\s+/g, '');

		// Vervang komma door punt
		cleaned = cleaned.replace(/,/g, '.');

		// Behoud alleen de eerste punt als decimaal scheider, verwijder alle anderen
		const parts = cleaned.split('.');
		if (parts.length > 2) {
			cleaned = parts[0] + '.' + parts.slice(1).join('');
		}

		// Zet om naar getal en format met 2 decimalen
		const numValue = parseFloat(cleaned);

		if ((!numValue && numValue !== 0) || isNaN(numValue)) {
			this.control?.setValue(null);
		} else {
			// Format met 2 decimalen
			const formatted = numValue.toFixed(2);

			// Split in geheel en decimaal deel
			const [integer, decimal] = formatted.split('.');

			// Voeg spaties toe tussen duizendtallen in het geheel deel
			const integerFormatted = integer.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');

			// Zet samen
			const result = integerFormatted + '.' + decimal;

			this.control?.setValue(result);
		}
	}

	protected afterInit() {
		switch (this.type) {
			case 'price':
				return this.formatPrice();
			case 'price-decimal':
				return this.formatPriceDecimal();
		}
	}
}
